export default {
  public_vapid_key: 'BLq8ZDFS_qCz11mfpLM08KuyKc94nUaE3ffJRaTW_B-f-pdNHb_80zwp83JWWiZm0KjP7NbbllR3teD-NsHZxis',
  config: {
    apiKey: 'AIzaSyD0XkY-Bz0otD9Ucq-zd_atG5cYcM92-Co',
    authDomain: 'suitup-172013.firebaseapp.com',
    databaseURL: 'https://suitup-172013.firebaseio.com',
    projectId: 'suitup-172013',
    storageBucket: 'suitup-172013.appspot.com',
    messagingSenderId: '392384096986',
    appId: '1:392384096986:web:27d9b45b30a53ce8'
  }
}
